import { render, staticRenderFns } from "./CookieSettings.vue?vue&type=template&id=3456d406&scoped=true&"
import script from "./CookieSettings.vue?vue&type=script&lang=js&"
export * from "./CookieSettings.vue?vue&type=script&lang=js&"
import style0 from "./CookieSettings.vue?vue&type=style&index=0&id=3456d406&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456d406",
  null
  
)

export default component.exports